"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactQuery = require("@tanstack/react-query");
var _vehicleHealth = _interopRequireDefault(require("../../services/vehicle-health"));
const useRawVehicleHealthReportByVin = function (vin, options) {
  const service = (0, _vehicleHealth.default)();
  const query = (0, _reactQuery.useQuery)({
    enabled: !!vin,
    queryKey: ["vehicle-health-report", vin],
    queryFn: async function () {
      if (!vin) return undefined;
      const {
        data
      } = await service.findVehicleHealthReport(vin);
      return data;
    },
    ...options
  });
  return {
    ...query,
    isLoading: query.isLoading && query.fetchStatus !== "idle"
  };
};
var _default = exports.default = useRawVehicleHealthReportByVin;